import { tempoApi } from '@/lib/api/tempoApi';
import type {
  CreateEstimationSchemeRequest,
  EstimationScheme,
  PatchEstimationSchemeRequest,
} from '@/lib/api/types/estimationScheme';

const getSchemeDetails = async (params: { schemeId: number }) =>
  await tempoApi()
    .get(`api/v1/item-store/estimation-schemes/${params.schemeId}`)
    .json<EstimationScheme>();

const getEstimationSchemes = async () =>
  await tempoApi().get('api/v1/item-store/estimation-schemes').json<EstimationScheme[]>();

const createScheme = async (data: CreateEstimationSchemeRequest) =>
  await tempoApi()
    .post('api/v1/item-store/estimation-schemes', { json: data })
    .json<EstimationScheme>();

const updateScheme = async ({
  schemeId,
  data,
}: {
  schemeId: number;
  data: PatchEstimationSchemeRequest;
}) =>
  await tempoApi()
    .patch(`api/v1/item-store/estimation-schemes/${schemeId}`, { json: data })
    .json<EstimationScheme>();

const duplicateScheme = async ({ schemeId }: { schemeId: number }) =>
  await tempoApi()
    .post(`api/v1/item-store/estimation-schemes/${schemeId}/duplicate`)
    .json<EstimationScheme>();

export const EstimationSchemesApi = {
  createScheme,
  duplicateScheme,
  getEstimationSchemes,
  getSchemeDetails,
  updateScheme,
} as const;
